<template>
    <v-sheet>
        <main-recruitment-tit v-bind="{ title, route }" />
        <v-row>
            <template v-for="item in items">
                <v-col cols="12" sm="6" md="3" :key="item._id">
                    <main-recruitment-card :recruitment="item" />
                </v-col>
            </template>
        </v-row>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_LIST_SORTS } from "@/assets/variables";

import MainRecruitmentTit from "./main-recruitment-tit.vue";
import MainRecruitmentCard from "./main-recruitment-card.vue";

const itemLength = 4;
const initHeaders = (headers = {}) => ({
    ...headers,
    sort: headers?.sort || RECRUITMENT_LIST_SORTS.CREATED_AT_DESC.sort,
    limit: headers?.limit || itemLength * 2,
});

export default {
    components: {
        MainRecruitmentTit,
        MainRecruitmentCard,
    },
    props: {
        title: { type: String, default: "최근 게시된 채용공고" },
        route: { type: [String, Object], default: "/recruitments" },

        params: { type: Object, default: () => ({}) },
        headers: { type: Object, default: initHeaders },
    },
    data: () => ({
        recruitments: [],

        loading: false,
    }),
    computed: {
        items() {
            const shuffled = this.recruitments.sort(() => 0.5 - Math.random());
            const selected = shuffled.slice(0, this.headers.limit / 2);
            return selected;
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        headers() {
            this.search();
        },
        params() {
            this.search();
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { headers, params } = this;
                const { recruitments = [] } = await api.v1.recruitments.gets({ headers, params });
                this.recruitments = recruitments;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>